import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '@/layout/MainLayout';
import Login from '@/view/Login';
import Dashboard from '@/view/Dashboard';
import Entrymanagement from '@/view/Entrymanagement';
import PlaceManagement from '@/view/PlaceManagement';
import IdCardManagement from '@/view/IdCardManagement';

const isAuthenticated = () => {
  const token = sessionStorage.getItem('accessToken');
  return !!token;
};

const Router = () => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route path="/login" element={<Login />} />
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/entrymanagement" element={<Entrymanagement />} />
          <Route path="/placemanagement" element={<PlaceManagement />} />
          <Route path="/idcardmanagement" element={<IdCardManagement />} />
        </Route>
      </Routes>
    </>
  );
};

export default Router;
